import React from 'react'
import { useTranslation } from 'react-i18next'
import icons from '../assets/icons'

const Close: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='modal--closeContainer'>
      <div className='modal--closeContainer--chevron'>
        <img src={icons['arrow-right']} />
      </div>
      <p className='modal--closeContainer--text'>{t('close').toUpperCase()}</p>
      <div className='modal--closeContainer--chevron'>
        <img src={icons['arrow-right']} />
      </div>
    </div>
  )
}

export default Close
